import { render, staticRenderFns } from "./IbPill.vue?vue&type=template&id=8f4e2872&scoped=true"
import script from "./IbPill.vue?vue&type=script&lang=js"
export * from "./IbPill.vue?vue&type=script&lang=js"
import style0 from "./IbPill.vue?vue&type=style&index=0&id=8f4e2872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4e2872",
  null
  
)

export default component.exports